import { makeStyles } from "@material-ui/styles";

export default makeStyles((theme) => ({
  container: {
    height: "90%",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    position: "relative",
  },
  table: {
    minWidth: "100%",
  },
}));
